import { render, staticRenderFns } from "./KeywordField.vue?vue&type=template&id=f3dd5768&scoped=true&"
import script from "./KeywordField.vue?vue&type=script&lang=ts&"
export * from "./KeywordField.vue?vue&type=script&lang=ts&"
import style0 from "./KeywordField.vue?vue&type=style&index=0&id=f3dd5768&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3dd5768",
  null
  
)

export default component.exports